import { render, staticRenderFns } from "./examination-detail.vue?vue&type=template&id=07526f56&scoped=true&"
import script from "./examination-detail.vue?vue&type=script&lang=js&"
export * from "./examination-detail.vue?vue&type=script&lang=js&"
import style0 from "./examination-detail.vue?vue&type=style&index=0&id=07526f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07526f56",
  null
  
)

export default component.exports